import React from 'react';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
/*
TODO: Потом можно использовать
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';
import { ContentBlock } from 'components/modules/AutoruLayout/ContentBlock/ContentBlock';
*/
import { Stepper } from '../Stepper/Stepper';
/*
TODO: Потом можно использовать
import { VehicleStatus } from '../VehicleStatus/VehicleStatus';

import { Autofill } from './components/Autofill/Autofill';*/

import { Loading } from '../Loading/Loading';

import { useCreateNewPresenter } from './CreateNew.presenter';

export const CreateNew = () => {
  useCreateNewPresenter();

  return (
    <Page aside={<Stepper />}>
      <Loading />
    </Page>
  );

  // TODO: Потом можно использовать
  /*return (
    <Page aside={<Stepper />}>
      <PageContent
        title="Сведения о транспортном средстве"
        description="Введите VIN, госномер автомобиля или загрузите ПТС&nbsp;одним PDF файлом, мы&nbsp;проанализируем и&nbsp;заполним данные по&nbsp;автомобилю автоматически"
      >
        <ContentBlock>
          <VehicleStatus />
          <Autofill />
        </ContentBlock>
      </PageContent>
    </Page>
  );*/
};
